import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import useMediaQuery from "../../app/common/hooks/useMediaQuery";
import { useNavigate } from "react-router-dom";
import { Button, Loader, Popup } from "semantic-ui-react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Avatar from "@mui/material/Avatar";
import { ReactComponent as LogoSvg } from "../../assets/altlogo.svg";
import { ReactComponent as Logo2Svg } from "../../assets/altlogo2.svg";
import { ReactComponent as AltBankLogoSvg } from "../../assets/altbanklogo.svg";
import { ReactComponent as EnigmaSvg } from "../../assets/enigma.svg";
import { ReactComponent as UserSvg } from "../../assets/user.svg";
import { ReactComponent as DownIconSvg } from "../../assets/downicon.svg";
import { ReactComponent as PlaySvg } from "../../assets/play.svg";
import { ReactComponent as InvertedPlaySvg } from "../../assets/invertedPlay.svg";
import { ReactComponent as StepArrowSvg } from "../../assets/arrow.svg";
import { ReactComponent as ScrollArrowSvg } from "../../assets/scrollarrow.svg";
import { ReactComponent as CBNLogoSvg } from "../../assets/CBNLOGO.svg";
import { ReactComponent as TABLogoSvg } from "../../assets/TABLOGO.svg";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";
import agent from "../../app/api/agent";
import { UserProfile } from "../../app/models/user";

const IndexHomePage = () => {
  const [checked, setChecked] = useState(false);
  const matches = useMediaQuery("(min-width: 800px)");
  const navigate = useNavigate();
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const { commonStore, userStore } = useStore();
  const loggedInUser = () => {
    try {
      const data = window.localStorage.getItem("user");
      return agent.decryptResponse(data);
    } catch {
      return null;
    }
  };
  const { GetItem, loadingInitial, getVendors, storeList } = commonStore;
  const token: string | null = GetItem("jwt");
  const { logout } = userStore;

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const scrollDown = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };
  const youtube = process.env.REACT_APP_YOUTUBE_EMBED_URL;
  const faq = process.env.REACT_APP_FAQ_URL;
  const returnPolicy = process.env.REACT_APP_RETURN_POLICY;
  const privacyPolicy = process.env.REACT_APP_PRIVACY_POLICY;
  const termsAndConditions = process.env.REACT_APP_T_AND_C;
  const paymentOptions = process.env.REACT_APP_PAYMENT_OPTIONS;
  const deliveryInformation = process.env.REACT_APP_DELIVERY_INFORMATION;
  const powerOptions = process.env.REACT_APP_POWER_OPTIONS;
  const aboutUs = process.env.REACT_APP_ABOUT;

  const isHttpUrl = (value: string) => /^https?:\/\//i.test(value);
const isDataUrl = (value: string) => /^data:/i.test(value);


const detectImageMime = (base64: string): string => {
  const sig = base64.slice(0, 24);
  if (sig.startsWith("iVBORw0KGgo")) return "image/png";
  if (sig.startsWith("/9j/")) return "image/jpeg";
  if (sig.startsWith("R0lGOD")) return "image/gif";
  if (sig.startsWith("UklGR")) return "image/webp";
  // Reasonable default for product photos when the signature is unrecognized
  return "image/png";
};

const resolveImageSrc = (value?: string | null): string | undefined => {
  if (!value || value === null) return undefined;

  // Already a normal URL or a properly formed data URI — use as-is
  if (isHttpUrl(value) || isDataUrl(value)) return value;

  // Otherwise treat it as raw base64 and build the data URI ourselves
  const cleaned = value.replace(/\s/g, "");
  const mime = detectImageMime(cleaned);
  return `data:${mime};base64,${cleaned}`;
};


  useEffect(() => {
    getVendors();
    // .catch();
  }, []);
  return (
    <>
      <div className={styles.origin}>
        <div className={styles.mainWrapper}>
          <div className={styles.page}>
            <div className={styles.navWrapper}>
              <div className={styles.nav}>
                <div
                  // type="checkbox"
                  className={`${styles.navcheck} ${checked && styles.checked}`}
                  // defaultChecked={false}
                  // checked={checked}
                />
                <div className={styles.navheader}>
                  <div className={styles.navtitle}>
                    {/* <img
                  src={altlogo}
                  style={{
                    width: matches ? "150px" : "150px",
                    cursor: "pointer",
                  }}
                  alt="logo"
                  onClick={() => navigate("/")}
                /> */}
                    <LogoSvg onClick={() => navigate("/")} />
                  </div>
                </div>
                <div
                  className={styles.navbtn}
                  onClick={() => setChecked(!checked)}
                >
                  <label htmlFor="navcheck">
                    <span></span>
                    <span></span>
                    <span></span>
                  </label>
                </div>

                <div className={styles.navlinks}>
                  {/* <a href="//github.io/jo_geek" target="_blank" rel="noreferrer">
              Github
            </a> */}
                  {/* <a href="/" target="_blank" rel="noreferrer">
              Stackoverflow
            </a> */}
                  {/* <a href="/" target="_blank" rel="noreferrer">
              LinkedIn
            </a>
            <a href="/" target="_blank" rel="noreferrer">
              Codepen
            </a> */}
                  <span>
                    {" "}
                    <div className={styles.flexCenter}>
                      <EnigmaSvg />
                      <span>Help</span>
                      <Popup
                        trigger={<DownIconSvg style={{ cursor: "pointer" }} />}
                        content={
                          <div className={styles.menu}>
                            <div
                              onClick={() => window.open(faq, "_blank")}
                              style={{ cursor: "pointer" }}
                            >
                              FAQs
                            </div>
                            <hr />
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => scrollDown()}
                            >
                              Contact Us
                            </div>
                            <hr />
                            {returnPolicy && (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  window.open(returnPolicy, "_blank")
                                }
                              >
                                Return Policy
                              </div>
                            )}
                          </div>
                        }
                        on="click"
                        position="bottom center"
                      />
                    </div>
                  </span>
                  <span>
                    {" "}
                    <div className={styles.flexCenter}>
                      <UserSvg />
                      <span
                        style={{
                          cursor: !token || token === null ? "pointer" : "",
                        }}
                        onClick={() =>
                          (!token || token === null) && navigate("/login")
                        }
                      >
                        {loggedInUser() ? "Account" : "Sign in"}
                      </span>
                      {loggedInUser() && matches && (
                        <Popup
                          trigger={
                            loggedInUser() && (
                              <DownIconSvg style={{ cursor: "pointer" }} />
                            )
                          }
                          header={`${
                            loggedInUser() && loggedInUser()!.firstName
                          } ${
                            loggedInUser() && loggedInUser().lastName !== null
                              ? loggedInUser().lastName
                              : ""
                          }`}
                          content={
                            <div className={styles.menu}>
                              <hr />
                              <div
                                onClick={() => navigate("/vendor/dashboard")}
                                style={{ cursor: "pointer" }}
                              >
                                Dashboard
                              </div>
                              <hr />
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => logout()}
                              >
                                Log Out
                              </div>
                            </div>
                          }
                          on="click"
                          position="bottom center"
                        />
                      )}
                    </div>
                  </span>
                  {/* <span className={styles.next}>
                <Button
                  positive
                  className={styles.positive}
                  onClick={() => navigate("/")}
                >
                  <div className={styles.flexCenter}>
                    <div className={styles.flexCenter}>
                      <CartSvg />
                      <span>Cart</span>
                    </div>
                    <Label circular color={"green"}>
                      2
                    </Label>
                  </div>
                </Button>
              </span> */}
                </div>
              </div>
            </div>
            <div className={styles.bannerWrapper}>
              <div className={styles.banner}>
                <div className={styles.bannerInfo}>
                  <div>
                    <h2>Contribute to providing clean energy to Nigerians.</h2>
                    <h5>Start selling on AltPower now</h5>
                    <div className={styles.next}>
                      <Button
                        positive
                        className={styles.bannerPositive}
                        onClick={() => navigate("/register")}
                      >
                        <div className={styles.flexCenterBetween}>
                          <span>Get started</span>
                          <PlaySvg />
                        </div>
                      </Button>
                    </div>
                  </div>
                </div>
                <div className={styles.bannerImage}>
                  <div className={styles.engineer}></div>
                  <div className={styles.bolt}></div>
                </div>
              </div>
            </div>
            <div className={styles.benefitsSectionWrapper}>
              <div className={styles.benefitsSection}>
                <div className={styles.benefitsImage}></div>
                <div className={styles.benefitsAccordion}>
                  <h4>Benefits and process of selling on AltPower</h4>
                  <div>
                    <Accordion
                      expanded={expanded === "panel1"}
                      onChange={handleChange("panel1")}
                      sx={{
                        backgroundColor: "#1A2E35",
                        color: "white",
                        marginBottom: "8px",
                      }}
                      disableGutters
                      className={styles.Accordion}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                        sx={{ minHeight: "56px" }}
                      >
                        {expanded === "panel1" ? (
                          <Typography
                            sx={{
                              width: "100%",
                              flexShrink: 0,
                              fontWeight: "700",
                              fontFamily: "Montserrat",
                            }}
                          >
                            Why you should use Altpower
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              width: "100%",
                              flexShrink: 0,
                              fontFamily: "Montserrat",
                            }}
                          >
                            Why you should use Altpower
                          </Typography>
                        )}
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{ backgroundColor: "#FBFBFB", color: "#828282" }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                            paddingTop: "30px",
                            paddingBottom: "50px",
                            fontWeight: "400",
                            fontFamily: "Montserrat",
                            lineHeight: "14.63px",
                          }}
                        >
                          <ul
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "15px",
                            }}
                          >
                            <li>
                              <b>Reach a massive audience:</b> Millions of
                              people shop on Altpower every day, giving you
                              access to a huge potential customer base searching
                              for solar products.
                            </li>
                            <li>
                              <b>Access to financing of your customer base:</b>
                              Altpower is a power solution platform that offers
                              customers a reliable and efficient power source
                              and flexible payment options to select from. ·
                              Increased brand awareness: Being listed on
                              Altpower can help increase brand awareness and
                              credibility for your business.
                            </li>
                            <li>
                              <b>Potential for high volume sales:</b> Altpower
                              can generate significant sales volume for your
                              products if they are successful.
                            </li>
                          </ul>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      expanded={expanded === "panel2"}
                      onChange={handleChange("panel2")}
                      sx={{
                        backgroundColor: "#1A2E35",
                        color: "white",
                        marginBottom: "8px",
                      }}
                      disableGutters
                      className={styles.Accordion}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                        sx={{ minHeight: "56px" }}
                      >
                        {expanded === "panel2" ? (
                          <Typography
                            sx={{
                              width: "100%",
                              flexShrink: 0,
                              fontWeight: "700",
                              fontFamily: "Montserrat",
                            }}
                          >
                            What you stand to gain
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              width: "100%",
                              flexShrink: 0,
                              fontFamily: "Montserrat",
                            }}
                          >
                            What you stand to gain
                          </Typography>
                        )}
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{ backgroundColor: "#FBFBFB", color: "#828282" }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                            paddingTop: "30px",
                            paddingBottom: "50px",
                            fontWeight: "400",
                            fontFamily: "Montserrat",
                            lineHeight: "14.63px",
                          }}
                        >
                          <ul
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "15px",
                            }}
                          >
                            {/* <li>
                              <b>Increased Payment processing:</b> Altpower
                              handles secure payment processing, simplifying
                              financial transactions by increased customers.
                            </li> */}
                            <li>
                              <b>Increased Payment processing:</b> Altpower
                              handles secure payment processing, simplifying
                              financial transactions by increased customers.
                            </li>
                            <li>
                              <b>Improved brand perception:</b> Being listed on
                              Altpower can lend credibility and trust to your
                              brand.
                            </li>
                            <li>
                              <b>Improved product discoverability:</b>{" "}
                              Altpower's powerful search engine and product
                              recommendations can significantly increase product
                              visibility.
                            </li>
                          </ul>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      expanded={expanded === "panel3"}
                      onChange={handleChange("panel3")}
                      sx={{ backgroundColor: "#1A2E35", color: "white" }}
                      disableGutters
                      className={styles.Accordion}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                        sx={{ minHeight: "56px" }}
                      >
                        {expanded === "panel3" ? (
                          <Typography
                            sx={{
                              width: "100%",
                              flexShrink: 0,
                              fontWeight: "700",
                              fontFamily: "Montserrat",
                            }}
                          >
                            How can you get your products on AltPower?
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              width: "100%",
                              flexShrink: 0,
                              fontFamily: "Montserrat",
                            }}
                          >
                            How can you get your products on AltPower?
                          </Typography>
                        )}
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{ backgroundColor: "#FBFBFB", color: "#828282" }}
                      >
                        <Typography
                          sx={{
                            fontSize: "12px",
                            paddingTop: "30px",
                            paddingBottom: "50px",
                            fontWeight: "400",
                            fontFamily: "Montserrat",
                            lineHeight: "14.63px",
                          }}
                        >
                          You need to click on the “<b>Get Started</b>” to
                          register to become a vendor and enjoy access to more
                          customers and transactions like never before! Buy Now!
                          Pay Later!
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.getStartedWrapper}>
              <div className={styles.getStarted}>
                <h2>Get started in 3 easy steps.</h2>
                <div className={styles.stepSections}>
                  <div className={styles.stepSection}>
                    <div className={styles.stepImage1}></div>
                    <div>
                      <div className={styles.stepHeader}>
                        <Avatar
                          sx={{
                            bgcolor: "#DFF2E7",
                            color: "#000000",
                            width: 33,
                            height: 33,
                            fontSize: 16,
                            fontWeight: "700",
                            fontFamily: "Montserrat",
                          }}
                          alt="Remy Sharp"
                          src="/broken-image.jpg"
                        >
                          1
                        </Avatar>
                        <h5>Register your accout</h5>
                      </div>
                      <div className={styles.stepInfo}>
                        Complete the Vendor Checklist Fill the registration form
                        and Submit other required documents{" "}
                      </div>
                    </div>
                  </div>
                  <div className={styles.stepArrow}>
                    <StepArrowSvg />
                  </div>
                  <div className={styles.stepSection}>
                    <div className={styles.stepImage2}></div>
                    <div>
                      <div className={styles.stepHeader}>
                        <Avatar
                          sx={{
                            bgcolor: "#DFF2E7",
                            color: "#000000",
                            width: 33,
                            height: 33,
                            fontSize: 16,
                            fontWeight: "700",
                            fontFamily: "Montserrat",
                          }}
                          alt="Remy Sharp"
                          src="/broken-image.jpg"
                        >
                          2
                        </Avatar>
                        <h5>Setup your Store</h5>
                      </div>
                      <div className={styles.stepInfo}>
                        Setup your store Provide your account details and get
                        verified by our team
                      </div>
                    </div>
                  </div>
                  <div className={styles.stepArrow}>
                    <StepArrowSvg />
                  </div>
                  <div className={styles.stepSection}>
                    <div className={styles.stepImage3}></div>
                    <div>
                      <div className={styles.stepHeader}>
                        <Avatar
                          sx={{
                            bgcolor: "#DFF2E7",
                            color: "#000000",
                            width: 33,
                            height: 33,
                            fontSize: 16,
                            fontWeight: "700",
                            fontFamily: "Montserrat",
                          }}
                          alt="Remy Sharp"
                          src="/broken-image.jpg"
                        >
                          3
                        </Avatar>
                        <h5>List your Products and Receiving Payments!</h5>
                      </div>
                      <div className={styles.stepInfo}>
                        List your products on your store Make your store public
                        and available to customers
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.getStartedButtonSection}>
                  <Button
                    positive
                    className={styles.getStartedPositive}
                    onClick={() => navigate("/register")}
                  >
                    <div className={styles.flexCenterBetween}>
                      <span>Start Selling now!</span>
                      <PlaySvg />
                    </div>
                  </Button>
                </div>
              </div>
            </div>
            <div className={styles.ourVendorsWrapper}>
              {loadingInitial === "loading" ? (
                <Loader active inline="centered" />
              ) : storeList && storeList.length > 0 ? (
                <div className={styles.ourVendors}>
                  <h2>Our Vendors</h2>
                  <div className={styles.vendorsList}>
                    {storeList.map((store, index) => {
                      const logoSrc = resolveImageSrc(store.storeLogo);
                      if (store.storeLogo && index < 9) {
                        return (
                          <div
                            className={styles.vendorBox}
                            key={index}
                            onClick={() => navigate(`/vendors/${store.slug}`)}
                          >
                            {/* <img src={store.storeLogo} alt="storelogo" /> */}
                            {logoSrc ? (
                            <img src={logoSrc} alt="storelogo" />
                          ) : (
                            <LogoSvg />
                          )}
                          </div>
                        );
                      } else return null;
                    })}
                  </div>

                  {storeList.length > 8 && (
                    <div className={styles.allVendors}>
                      See all vendors{" "}
                      <span>
                        <InvertedPlaySvg
                          onClick={() => navigate("/vendors")}
                          style={{ cursor: "pointer" }}
                        />
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className={styles.testimonialWrapper}>
              <div className={styles.testimonial}>
                <h2>Testimonials from our vendors</h2>
                <div className={styles.videoWrap}>
                  <div className={styles.topBox}></div>
                  <div className={styles.video}>
                    <iframe
                      width="100%"
                      height="100%"
                      src={`${youtube}?rel=0&controls=1`}
                      title="Be like Patrick"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <div className={styles.endBox}></div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.content}>
              <Logo2Svg />
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(aboutUs, "_blank")}>
                  About Us
                </div>
                <div onClick={() => window.open(termsAndConditions, "_blank")}>
                  Terms & Conditions
                </div>
                <div onClick={() => navigate("/login")}>My Account</div>
              </div>
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(deliveryInformation, "_blank")}>
                  Delivery Information
                </div>
                <div onClick={() => window.open(paymentOptions, "_blank")}>
                  Payment Options
                </div>
                <div onClick={() => window.open(powerOptions, "_blank")}>
                  Power As A Service
                </div>
              </div>
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(privacyPolicy, "_blank")}>
                  Privacy Policy
                </div>
                <div
                  onClick={() => window.open(faq, "_blank")}
                  className={styles.sterlink}
                >
                  FAQ
                </div>
                <div onClick={() => window.open(returnPolicy, "_blank")}>
                  Return Policy
                </div>
              </div>
              <div className={styles.footerlinks}>
                <h5>02017000555</h5>
                <div
                  className={styles.emaillink}
                  onClick={() =>
                    window.open("mailto:service@altpower.ng", "_blank")
                  }
                >
                  service@altpower.ng
                </div>
                {/* <div className={styles.altbanklogo}>
                  <AltBankLogoSvg />
                </div> */}
              </div>
            </div>
            <div className={styles.scrollup} onClick={() => scrollUp()}>
              <div className={styles.arrowdown}>
                {" "}
                <ScrollArrowSvg />
              </div>
            </div>
            <div className={styles.copyright}>
              <span>
                Licensed by Cental Bank Of Nigeria <CBNLogoSvg />
              </span>
              <span>|</span>
              <span>Powered by</span>
              <span>
                <TABLogoSvg />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(IndexHomePage);
